import React from 'react';
import i18n from 'i18next';
import { ChevronRight } from 'react-feather';

// Mobile drawer-ийн үндсэн цэс: serif том үсэг, доогуур нимгэн зураас.
const MenuDrawerItem = ({ menu, onClick }) => {
    const menuName =
        menu.names?.find((item) => item.langCode === i18n.language)?.name ||
        menu.names?.find((item) => item.langCode === 'mn')?.name;

    return (
        <li
            className="flex items-center justify-between py-3.5 border-b border-line cursor-pointer text-ink"
            onClick={onClick}
        >
            <span className="font-philosopher text-[22px] leading-none">
                {menuName}
            </span>
            {menu.children && menu.children.length > 0 && (
                <ChevronRight size={18} className="text-ink/50" />
            )}
        </li>
    );
};

export default MenuDrawerItem;
